<svg
  #svgRoot
  class="ink-layer"
  [class.is-interactive]="isInteractive"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerUp($event)"
  aria-label="Ink layer"
>
  <g [attr.transform]="viewportTransform">
    <ng-container *ngFor="let s of renderStrokes; trackBy: trackById">
      <path
        [attr.d]="s.d"
        [attr.fill]="s.fill"
        [attr.stroke]="s.stroke"
        [attr.stroke-width]="s.strokeWidth"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </ng-container>
  </g>
</svg>

